<template>
<div id="regi">
    <div id="pw_wrap" class="pw_layer" v-bind:style="{backgroundImage: 'url(' + store_bg_image + ')', backgroundSize: '100%'} ">
        <!-- <div class="logo" v-bind:style="{width: logo_width_size+'px' , height: logo_height_size+'px'}"><img :src="store_main_image" /></div> -->
        <div class="pw-container-wrap">
            <div class="pw-container">
                <!-- <div class="pw-head ">
                <div class="pw-text"> <span :style="{color: this.text_color}">비밀번호변경</span> </div>
            </div> -->
                <div class="pw_box" v-if="!user_flag">
                    <div class="pw-body">
                        <template>
                            <div class="hp_form form_wrap">
                                <div class="form-title">가입매장 검색</div>
                                <div class="form-content">
                                    <label for="hp" style="display:none;">휴대폰번호</label>
                                    <input type="text" v-model="user_hp" ref='user_hp' v-on:focus='inputFocus("user_hp")' @keyup="autoHyphen" class="input-touch" full_length="13" name="user_hp" value="010" placeholder="휴대폰 번호">
                                    <div class="btn_box">
                                        <div class="cancel_btn01" @click="search_store">검색</div>
                                    </div>
                                </div>
                            </div>
                            <div class="store_form form_wrap" v-if="store_list.length > 0">
                                <div class="form-title">매장 선택</div>
                                <div class="storeselect">
                                    <ul>
                                        <li v-for="(item, index) in store_list" :class="{ 'on' : isStoreSelState(item.store_id) }" :key="index" @click="set_store(item)">
                                            <div>{{item.store_name}}</div>
                                            <div class="check"></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="code_form form_wrap" v-if="set_store_flag">
                                <div class="form-title">인증
                                    <a><span class="send-auth" @click="chk_phone_number">인증번호 요청</span></a>
                                </div>
                                <div class="form-content">
                                    <label for="code" style="display: none;">인증번호 입력</label>
                                    <input name="code_num" ref="code_num" type="text" v-model="code_num" id="code" full_length="4" title="인증번호 입력" placeholder="인증번호 입력">
                                    <div class="btn_box">
                                        <div class="cancel_btn01" @click="certification_chk">확인</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template>
                            <div class="change_form form_wrap" v-if="auth_yn">
                                <div class="form-title">비밀번호 설정</div>
                                <div class="form-content">
                                    <label for="pw_change" style="display: none;">변경비밀번호</label>
                                    <input name="pw_change" ref="pw_change" v-model="pw_change" type="password" full_length="4" value="" id="pw_change" title="변경비밀번호" placeholder="변경비밀번호">
                                    <label for="pw_check" style="display: none;">비밀번호확인</label>
                                    <input name="pw_check" type="password" ref="pw_check" v-model="pw_check" id="pw_check" full_length="4" title="비밀번호확인" placeholder="비밀번호확인">
                                </div>
                            </div>
                        </template>
                        <div class="btn_box">
                            <div class="btn-cancel" @click="close">취소</div>
                            <div class="btn-ok" v-if="auth_yn" @click="change_password">확인</div>
                        </div>
                    </div>

                </div>

                <div class="pw_box" v-if="user_flag">
                    <div class="pw-body">
                        <template>
                            <div class="change_form form_wrap" v-if="auth_yn">
                                <div class="form-title">비밀번호 설정</div>
                                <div class="form-content">
                                    <label for="pw_change" style="display: none;">변경비밀번호</label>
                                    <input name="pw_change" ref="pw_change" v-model="pw_change" type="password" full_length="4" value="" id="pw_change" title="변경비밀번호" placeholder="변경비밀번호">
                                    <label for="pw_check" style="display: none;">비밀번호확인</label>
                                    <input name="pw_check" type="password" ref="pw_check" v-model="pw_check" id="pw_check" full_length="4" title="비밀번호확인" placeholder="비밀번호확인">
                                </div>
                            </div>
                        </template>
                        <div class="btn_box">
                            <div class="btn-cancel" @click="go_back_mypage">취소</div>
                            <div class="btn-ok" v-if="auth_yn" @click="change_password">확인</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import common from '@/javascript/common.js'

// 사용자 정의 모듈.
import * as config from '../../javascript/config';

import vue from 'vue';

const FOCUS_TYPE = {
    SIGN_ID: {
        name: 'user_hp',
        type: 'KEYBOARD'
    },
    SIGN_PASS: {
        name: 'user_password',
        type: 'KEYBOARD'
    },
}
export default {
    data: function () {
        return {
            user_hp: '',
            pw_change: '',
            pw_check: '',
            code_num: '',
            password: '',
            store_list: [],
            sel_store_id: '',
            sel_store_list: '',
            store_user_id: '',

            set_store_flag: false,

            auth_yn: false,
            store_main_image: '',
            req_user_id: '',
            logo_width_size: 0,
            logo_height_size: 0,

            store_bg_image: '',
            text_color: '',
            user_flag: false
        }
    },
    props: [],
    methods: {
        go_back_mypage(){
            this.$router.push("/mypage");
        },
        isStoreSelState(id) {
            if (id === parseInt(this.sel_store_id)) return true;
            else false;
        },
        autoHyphen() {
            if (this.user_hp.length > 13) {
                this.user_hp = this.user_hp.substr(0, 13);
            } else {
                var val = this.user_hp.replace(/\D/g, '');
                var original = this.user_hp.replace(/\D/g, '').length;
                var conversion = '';
                for (let i = 0; i < 3; i++) {
                    if (val.length > 3 && i === 0) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 6 && val.length > 3 && i === 1) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 10 && val.length < 12 && i === 2) {
                        let value = this.user_hp.replace(/-/gi, "");
                        conversion = '';
                        this.user_hp = value.substring(0, 3) + '-' + value.substring(3, 7) + '-' + value.substring(7, 11);
                        return this.user_hp;
                    }
                }
                conversion += val;
                this.user_hp = conversion;
            }
        },
        inputFocus(type) {
            const focusObjectList = Object.values(FOCUS_TYPE);
            focusObjectList.forEach(
                (element) => {
                    if (element.name == type) this.current_focus = element;
                }
            );

            this.parent_key_str = this[this.current_focus.name];
        },
        set_store(item) {
            this.sel_store_id = item.store_id;
            this.store_user_id = item.user_id;
            this.store_tel_number = item.store_tel_number;
            this.set_store_flag = true;
        },
        close() {
            this.$router.push("/start");
        },
        search_store() {
            if (this.user_hp == "") {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `휴대폰번호를 입력해주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return false;
            } else {
                const type = config.REQ_JOIN_STORE_LIST;
                const data = {
                    user_hp: this.user_hp
                };
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    this.store_list = response;
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }

        },
        chk_phone_number() {
 
            this.sel_store_list = this.store_list.filter((v) => (v.store_id === this.sel_store_id))
            
            const type = config.REQ_MOBILE_MEMBER_AUTH_REQ;
            const data = {
                'data': {
                    'user_hp': this.user_hp,
                    'store_id': this.sel_store_id,
                    'user_id': this.store_user_id,
                    'store_tel_number': this.store_tel_number,
                    'store_name': this.sel_store_list[0].store_name
                }
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                if (response.result) {
                    this.req_user_id = response.user_id;
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `인증번호를 전송하였습니다.`,
                        router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);

                    return false;
                } else {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `입력하신 사용자의 정보가 없습니다`,
                        router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    this.auth_yn = false;
                    return false;
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },
        certification_chk() {
            if (this.code_num == '') {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `인증 번호를 입력해주세요`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return false;
            }
            if (this.req_user_id === '') {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `인증번호 요청 후 이용해주세요`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
            } else {
                const type = config.REQ_MOBILE_MEMBER_AUTH_CHECK;
                const data = {
                    data: {
                        'store_id': this.sel_store_id,
                        'user_id': this.store_user_id,
                        'user_hp': this.user_hp,
                        'auth_num': this.code_num
                    }
                };

                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    if (response.result) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `본인 인증이 완료되었습니다.`,
                            router: '',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        this.auth_yn = true;

                        return false;
                    } else {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `인증번호를 확인 후 다시 이용해주세요`,
                            router: '',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        this.auth_yn = false;
                        return false;
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });

            }
        },
        change_password() {
            if (this.pw_change == '' || this.pw_change == "") {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `비밀번호를 입력해주세요`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return false;
            }
            if (this.pw_change != this.pw_check) {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `비밀번호가 일치 하지 않습니다`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return false;
            }
            if (this.auth_yn) {
                const type = config.REQ_MOBILE_MEMBER_USER_UPDATE;
                var data = {
                    'data': {
                        'req_user_ph': this.user_hp,
                        'req_user_id': this.req_user_id,
                        'password': this.pw_change,
                        'store_id':this.sel_store_id
                    }
                };
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    if (response.result) {
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `비밀번호가 변경되었습니다.`,
                            router: '',
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        if(this.user_flag){
                            this.go_back_mypage();
                        }else{
                            this.close();
                        }                        
                    }

                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            } else {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `본인 인증 후 이용해주세요`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return false;
            }
        }
    },
    mounted() {
        this.$nextTick(function () {
            // store_logo_image
            var user_data = this.$store.getters['getUser'];

            console.log(user_data);
            if (user_data.user_hp.length > 0) {
                this.user_flag = true;
                this.auth_yn = true;
                this.req_user_id = user_data.user_id;                
            } else {                
            }
        });
    },
    created() {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/page/password_edit.vue